export default __webpack_public_path__ + "static/media/sessions-image.4da46492.jpg";